import React from "react";
import classnames from "classnames";

const PERIOD_LIST = ["10d", "1m", "3m", "6m", "1y", "5y", "all"];

export default class PeriodShortcut extends React.Component {
	render() {
		let { settings, activePeriod, onSetViewPeriod } = this.props;
		return (
			<div className="shortcut pull-right" data-intro="quickly change the period of the chart" data-position="left">
				<ul>
					{PERIOD_LIST.map(each => 
						<li key={each}
							className={`period ${activePeriod === each ? "active" : ""}`}
							onClick={onSetViewPeriod.bind(null, each)}>{each}</li>)}
				</ul>
			</div>
		);
	}
}

/*
				<button type="button" className="btn btn-default">
					<span className="period">1</span>
				</button>
*/


/** WEBPACK FOOTER **
 ** ./src/scripts/components/page/ChartPage/PeriodShortcut.jsx
 **/